import { React } from 'react';
import { Field } from 'formik';


export default function AddressComponent({ disabled, errors, touched, values, handleChange, prefix, handleBlur }) {

  var street1Name = `${prefix}Street1`
  var street2Name = `${prefix}Street2`
  var cityName = `${prefix}City`
  var stateName = `${prefix}State`
  var zipcodeName = `${prefix}Zipcode`
  var containerId = `${prefix}AddressForm`

  return (
    <div id={containerId} className="space-y-4">
      {/* Street Address Line 1 */}
      <div>
        <label htmlFor={street1Name} className="block text-sm font-medium text-gray-700 mb-2">
          Street Address <span className="text-red-500">*</span>
        </label>
        <div>
          <Field 
            required
            name={street1Name}
            disabled={disabled}
            aria-label="Street Address"
            onChange={handleChange}
            onBlur={handleBlur}
            className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent disabled:bg-gray-100 disabled:cursor-not-allowed ${
              errors[street1Name] && touched[street1Name] 
                ? 'border-red-500 bg-red-50' 
                : 'border-gray-300'
            }`}
          />
          {errors[street1Name] && touched[street1Name] ? (
            <div className="mt-1 text-sm text-red-600">{errors[street1Name]}</div>
          ) : null}
        </div>
      </div>

      {/* Street Address Line 2 */}
      <div>
        <label htmlFor={street2Name} className="block text-sm font-medium text-gray-700 mb-2">
          Street Address Line 2
        </label>
        <div>
          <Field
            name={street2Name}
            disabled={disabled}
            aria-label="Street Address Line 2"
            onChange={handleChange}
            onBlur={handleBlur}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent disabled:bg-gray-100 disabled:cursor-not-allowed"
          />
        </div>
      </div>

      {/* City and State Row */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* City */}
        <div>
          <label htmlFor={cityName} className="block text-sm font-medium text-gray-700 mb-2">
            City <span className="text-red-500">*</span>
          </label>
          <div>
            <Field 
              required
              name={cityName}
              disabled={disabled}
              aria-label="City"
              onChange={handleChange}
              onBlur={handleBlur}
              className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent disabled:bg-gray-100 disabled:cursor-not-allowed ${
                errors[cityName] && touched[cityName] 
                  ? 'border-red-500 bg-red-50' 
                  : 'border-gray-300'
              }`}
            />
            {errors[cityName] && touched[cityName] ? (
              <div className="mt-1 text-sm text-red-600">{errors[cityName]}</div>
            ) : null}
          </div>
        </div>

        {/* State */}
        <div>
          <label htmlFor={stateName} className="block text-sm font-medium text-gray-700 mb-2">
            State <span className="text-red-500">*</span>
          </label>
          <div>
            <Field 
              required
              name={stateName}
              disabled={disabled}
              aria-label="State"
              onChange={handleChange}
              onBlur={handleBlur}
              className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent disabled:bg-gray-100 disabled:cursor-not-allowed ${
                errors[stateName] && touched[stateName] 
                  ? 'border-red-500 bg-red-50' 
                  : 'border-gray-300'
              }`}
            />
            {errors[stateName] && touched[stateName] ? (
              <div className="mt-1 text-sm text-red-600">{errors[stateName]}</div>
            ) : null}
          </div>
        </div>
      </div>

      {/* Zip Code */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label htmlFor={zipcodeName} className="block text-sm font-medium text-gray-700 mb-2">
            Zip Code <span className="text-red-500">*</span>
          </label>
          <div>
            <Field 
              required
              name={zipcodeName}
              disabled={disabled}
              aria-label="Zip Code"
              onChange={handleChange}
              onBlur={handleBlur}
              className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent disabled:bg-gray-100 disabled:cursor-not-allowed ${
                errors[zipcodeName] && touched[zipcodeName] 
                  ? 'border-red-500 bg-red-50' 
                  : 'border-gray-300'
              }`}
            />
            {errors[zipcodeName] && touched[zipcodeName] ? (
              <div className="mt-1 text-sm text-red-600">{errors[zipcodeName]}</div>
            ) : null}
          </div>
        </div>
        {/* Empty space for grid alignment */}
        <div></div>
      </div>
    </div>
  );


}